import { memo, useCallback } from 'react';
import { Box, Typography, IconButton } from '@mui/material';
import { ExpandMore as ExpandMoreIcon, ChevronRight as ChevronRightIcon } from '@mui/icons-material';
import { Button } from '../../../../components/shared';

const displayName = 'GroupHeader';

const GroupHeader = memo(({ group, isExpanded, onToggle, onSelectAll, onDeselectAll, classes }) => {
  const handleToggle = useCallback(
    (e) => {
      e.stopPropagation();
      onToggle(group.id);
    },
    [group.id, onToggle],
  );

  const handleSelectAll = useCallback(
    (e) => {
      e.stopPropagation();
      onSelectAll(group);
    },
    [group, onSelectAll],
  );

  const handleDeselectAll = useCallback(
    (e) => {
      e.stopPropagation();
      onDeselectAll(group);
    },
    [group, onDeselectAll],
  );

  return (
    <Box className={classes.groupHeader}>
      <Box className={classes.groupTitleRow} onClick={handleToggle}>
        <IconButton size="small" className={classes.groupExpandIcon}>
          {isExpanded ? <ExpandMoreIcon fontSize="small" /> : <ChevronRightIcon fontSize="small" />}
        </IconButton>
        <Typography variant="subtitle2" className={classes.groupLabel} sx={{ color: group.color }}>
          {group.label} ({group.count})
        </Typography>
      </Box>
      <Box className={classes.groupActionButtons}>
        <Button variant="text" size="small" onClick={handleSelectAll} className={classes.groupActionButton}>
          SELECT ALL ({group.count})
        </Button>
        <Button variant="text" size="small" onClick={handleDeselectAll} className={classes.groupActionButton}>
          DESELECT ALL
        </Button>
      </Box>
    </Box>
  );
});

GroupHeader.displayName = displayName;

export default GroupHeader;
